import React from 'react';
import { useTranslation } from 'react-i18next';

const Contact: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-32 bg-white text-center">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-5xl font-light mb-8">
          {t('contact.invite')}
        </h2>
        <a 
          href="mailto:hwang.archi@gmail.com" 
          className="text-xl md:text-2xl font-medium hover:opacity-60 transition-opacity mb-12 block"
        >
          hwang.archi@gmail.com
        </a>
        <button className="px-8 py-3 border border-black text-black text-sm uppercase tracking-widest hover:bg-black hover:text-white transition-colors duration-300">
          {t('contact.cta')}
        </button>
      </div>
    </section>
  );
};

export default Contact;
